<template>
  <div>
    <div class="clinic-doctor my-3">
      <nav class="nav nav-pills nav-fill mb-3 mx-3">
        <a
          class="nav-item nav-link"
          :class="{ active: current === 'schedule' }"
          @click.prevent="current = 'schedule'"
          href="#"
        >
          {{ $t("schedule") }}
        </a>
        <a
          class="nav-item nav-link"
          :class="{ active: current === 'manage' }"
          @click.prevent="current = 'manage'"
          href="#"
        >
          {{ $t("manage") }}
        </a>
      </nav>
    </div>
    <div>
      <transition name="slideNext">
        <template v-if="current === 'schedule'">
          <schedule :doctor-id.sync="$route.params.id"></schedule>
        </template>
        <template v-if="current === 'manage'">
          <manager :doctor-id.sync="$route.params.id"></manager>
        </template>
      </transition>
    </div>
  </div>
</template>
<script>
import Manager from '@/components/Schedule/Manager'
import Schedule from '@/components/Schedule/Schedule'
export default {
  components: {
    Manager,
    Schedule
  },
  metaInfo: {
    title: 'Clinic Doctor'
  },
  data () {
    return {
      current: 'schedule'
    }
  }
}
</script>
<style lang="scss">
.clinic-doctor {
  .nav {
    .nav-item {
      transition: all 0.2s linear;
      &.active {
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        position: relative;
        &::after {
          transition: all 0.2s linear;
          content: "";
          width: 0;
          height: 0;
          position: absolute;
          top: 40px;
          left: 50%;
          transform: translateX(-50%);
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 10px solid #3c88ff;
          clear: both;
        }
      }
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "schedule": "ვიზიტები",
      "manage": "განრიგის დაგეგმვა"
  }
}
</i18n>
